"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OperationLog',
  data: function data() {
    return {
      loading: false,
      logList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      dateRange: [],
      queryParams: {
        operation_source: '',
        operation_menu: '',
        operation_option: '',
        create_time: '' // 时间范围，格式：开始时间|结束时间
      },
      sourceOptions: [{
        label: 'PC端平台',
        value: 2
      }, {
        label: '微信小程序',
        value: 1
      }],
      dialogVisible: false,
      currentLog: {}
    };
  },
  watch: {
    /**
     * 监听日期范围变化
     */
    dateRange: function dateRange(val) {
      if (val && val.length === 2) {
        // 后端期望格式：开始时间|结束时间
        // 结束日期需要添加 23:59:59，确保查询当天所有数据
        var startTime = val[0] + ' 00:00:00';
        var endTime = val[1] + ' 23:59:59';
        this.queryParams.create_time = startTime + '|' + endTime;
      } else {
        this.queryParams.create_time = '';
      }
    }
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    /**
     * 获取操作日志列表
     */
    fetchData: function fetchData() {
      var _this = this;
      this.loading = true;
      var params = _objectSpread({
        page: this.currentPage,
        limit: this.pageSize
      }, this.queryParams);
      this.$get('agentapi/admin_operation/list', params).then(function (res) {
        _this.logList = res.list || [];
        _this.total = res.total || 0;
      }).catch(function (err) {
        _this.$message({
          message: '获取操作日志失败',
          type: 'error'
        });
      }).finally(function () {
        _this.loading = false;
      });
    },
    /**
     * 查询
     */
    handleFilter: function handleFilter() {
      this.currentPage = 1;
      this.fetchData();
    },
    /**
     * 重置查询条件
     */
    resetQuery: function resetQuery() {
      this.queryParams = {
        operation_source: '',
        operation_menu: '',
        operation_option: '',
        create_time: ''
      };
      this.dateRange = [];
      this.currentPage = 1;
      this.fetchData();
    },
    /**
     * 查看详情
     */
    handleView: function handleView(row) {
      this.currentLog = _objectSpread({}, row);
      this.dialogVisible = true;
    },
    /**
     * 分页 - 每页条数变化
     */
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    /**
     * 分页 - 当前页变化
     */
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    /**
     * 获取操作来源文本
     */
    getSourceText: function getSourceText(source) {
      var sourceMap = {
        1: '微信小程序',
        2: 'PC端平台'
      };
      return sourceMap[source] || '未知';
    },
    /**
     * 获取操作来源标签类型
     */
    getSourceTagType: function getSourceTagType(source) {
      var typeMap = {
        1: 'success',
        2: 'primary'
      };
      return typeMap[source] || 'info';
    }
  }
};